import './api/MicrosoftAPI.js';
import './entities/MicrosoftApiErrorLog.js';
import './entities/MicrosoftData.js';
import './entities/MicrosoftGroupData.js';
import './entities/MicrosoftUserData.js';
import './entities/MicrosoftUserState.js';
